













































import { Component, Prop, Vue, Watch, Mixins, Emit } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";
import Swiper from 'swiper';
import constants from '../store/constants';

@Component
export default class ContentSlideBuilding extends Vue {
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;
  hoveredElementNumber = 1;
  $refs!: {
    block1: HTMLElement;
    block2: HTMLElement;
  }

  @Prop({ default: '' })
  name!: string;

  @Prop({ default: '' })
  imageOne!: string;

  @Prop({ default: '' })
  imageTwo!: string;

  @Prop({ default: 0 })
  number!: number;

  @Prop({ default: [] })
  photos!: any;

  @Prop({ default: [] })
  videos!: any;

  openVideo() {
    this.$store.dispatch(constants.windowWithSliderContentChange, this.videos);
  }

  openPhoto() {
    this.$store.dispatch(constants.windowWithSliderContentChange, this.photos);
  }

  hover(number: number) {
    if (window.innerWidth > 650) {
      if (this.hoveredElementNumber == number) return;
      this.hoveredElementNumber = number;
      anime.remove([this.$refs.block1, this.$refs.block2]);
      anime({
        targets: this.$refs.block1,
        duration: 500,
        easing: "easeOutQuad",
        left: "-3%"
      });

      anime({
        targets: this.$refs.block2,
        duration: 500,
        easing: "easeOutQuad",
        right: "-3%"
      });

      setTimeout(() => {
        if (this.hoveredElementNumber !== number) return;
        this.$refs.block1.style.zIndex = (number == 2) ? "1" : "2";
        this.$refs.block2.style.zIndex = (number == 1) ? "1" : "2";
        anime({
          targets: this.$refs.block1,
          duration: 500,
          easing: "easeOutQuad",
          left: "0%"
        });

        anime({
          targets: this.$refs.block2,
          duration: 500,
          easing: "easeOutQuad",
          right: "0%"
        });
      }, 500)
    }
  }
}
